var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 76,
    viewBox: "0 0 103 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 0)",
    fill: "#6C82EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 0)",
    fill: "#6C82EF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 0)",
    fill: "#6C82EF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 0)",
    fill: "#6C82EF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 0)",
    fill: "#6C82EF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 0)",
    fill: "#6C82EF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 0)",
    fill: "#6C82EF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 6)",
    fill: "#6C82EF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 18)",
    fill: "#6C82EF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 30)",
    fill: "#6C82EF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 42)",
    fill: "#6C82EF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 54)",
    fill: "#6C82EF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 8 66)",
    fill: "#6C82EF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 6)",
    fill: "#6C82EF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 18)",
    fill: "#6C82EF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 30)",
    fill: "#6C82EF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 42)",
    fill: "#6C82EF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 54)",
    fill: "#6C82EF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 24 66)",
    fill: "#6C82EF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 6)",
    fill: "#6C82EF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 18)",
    fill: "#6C82EF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 30)",
    fill: "#6C82EF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 42)",
    fill: "#6C82EF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 54)",
    fill: "#6C82EF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 40 66)",
    fill: "#6C82EF"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 6)",
    fill: "#6C82EF"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 18)",
    fill: "#6C82EF"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 30)",
    fill: "#6C82EF"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 42)",
    fill: "#6C82EF"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 54)",
    fill: "#6C82EF"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 56 66)",
    fill: "#6C82EF"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 6)",
    fill: "#6C82EF"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 18)",
    fill: "#6C82EF"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 30)",
    fill: "#6C82EF"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 42)",
    fill: "#6C82EF"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 54)",
    fill: "#6C82EF"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 72 66)",
    fill: "#6C82EF"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 6)",
    fill: "#6C82EF"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 18)",
    fill: "#6C82EF"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 30)",
    fill: "#6C82EF"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 42)",
    fill: "#6C82EF"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 54)",
    fill: "#6C82EF"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 88 66)",
    fill: "#6C82EF"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 12)",
    fill: "#6C82EF"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 12)",
    fill: "#6C82EF"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 24)",
    fill: "#6C82EF"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 24)",
    fill: "#6C82EF"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 36)",
    fill: "#6C82EF"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 36)",
    fill: "#6C82EF"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 48)",
    fill: "#6C82EF"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 48)",
    fill: "#6C82EF"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 60)",
    fill: "#6C82EF"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 60)",
    fill: "#6C82EF"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 16 72)",
    fill: "#6C82EF"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 0 72)",
    fill: "#6C82EF"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 12)",
    fill: "#6C82EF"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 24)",
    fill: "#6C82EF"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 36)",
    fill: "#6C82EF"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 48)",
    fill: "#6C82EF"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 60)",
    fill: "#6C82EF"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 32 72)",
    fill: "#6C82EF"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 12)",
    fill: "#6C82EF"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 24)",
    fill: "#6C82EF"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 36)",
    fill: "#6C82EF"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 48)",
    fill: "#6C82EF"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 60)",
    fill: "#6C82EF"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 48 72)",
    fill: "#6C82EF"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 12)",
    fill: "#6C82EF"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 24)",
    fill: "#6C82EF"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 36)",
    fill: "#6C82EF"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 48)",
    fill: "#6C82EF"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 60)",
    fill: "#6C82EF"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 64 72)",
    fill: "#6C82EF"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 12)",
    fill: "#6C82EF"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 24)",
    fill: "#6C82EF"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 36)",
    fill: "#6C82EF"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 48)",
    fill: "#6C82EF"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 60)",
    fill: "#6C82EF"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 80 72)",
    fill: "#6C82EF"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 12)",
    fill: "#6C82EF"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 24)",
    fill: "#6C82EF"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 36)",
    fill: "#6C82EF"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 48)",
    fill: "#6C82EF"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 60)",
    fill: "#6C82EF"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(1.39071e-07 1 1 -1.39071e-07 96 72)",
    fill: "#6C82EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.506705a4eab291a28174a0c9ac747446.svg";
export { ForwardRef as ReactComponent };